<template>
  <div>
    <a
      v-if="Object.keys(banner).length"
      :href="banner.url_to_redirect[lang]"
      class="banner"
      :style="`color: ${banner.text_color}; background-color: ${banner.bg_color}`"
    >
      <div class="banner__section">
        <span class="hidden lg:block font-bold p-2 lg:text-base">{{ banner.center_text[lang] }}</span>
        <span class="lg:hidden p-2 text-xs">{{ banner.mobile_center_text[lang] }}</span>
      </div>
    </a>
  </div>
</template>
  
<script>
export default {

  name: 'banner-header',
  props: {
    currentRoute: {
      type: String,
      default: '',
    },
    banner: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lang: window.appLocale,
    }
  },
}
</script>
  
<style lang="scss" scoped>
  .banner {
    width: 100%;
    display: flex;
    justify-content: center;

  &__section {
    font-size: .875rem;

    display: flex;
    justify-content: center;
    align-items: center;

    @media(max-width:992px){
        width: 100%;
        font-size: .75rem;
    }

    .banner-title {
      background: black;
      font-weight: bold;
      color: white;
      padding: 3px 6px;
      margin-right: 12px;
      font-size: .875rem;

      @media(max-width:992px){
        font-size: .75rem;
    }
    }
  }
}
</style>